import request from '@/utils/request'

/**
 * 获取属性值列表
 * @param {Object} params 查询参数
 * @returns {Promise} Promise对象
 */
export function listAttrValue(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/attrValue.listAttrValue',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

/**
 * 添加属性值
 * @param {Object} data 属性值数据
 * @returns {Promise} Promise对象
 */
export function saveAttrValue(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/attrValue.saveAttrValue',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

/**
 * 修改属性值
 * @param {Object} data 属性值数据
 * @returns {Promise} Promise对象
 */
export function updateAttrValue(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/attrValue.updateAttrValue',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

/**
 * 删除属性值
 * @param {Object} data 属性值数据
 * @returns {Promise} Promise对象
 */
export function deleteAttrValue(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/attrValue.deleteAttrValue',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}